import React from 'react'
import './IncomingCall.css'

const IncomingCall: React.FC = () => {
  return (
    <div className="incoming-call-container">
      <span className="incoming-call-icon mgc_phone_call_fill" />
      Incoming call
    </div>
  )
}

export default IncomingCall
